import React, { useState, useEffect } from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import styled from "styled-components";

const StyledInput = styled(Input)`
  /* width: ${({ width }) => (width ? `${width}px` : '200px')}; */
  max-width: ${({ width }) => (width ? `${width}px` : '300px')};
  transition: all 0.3s ease-in-out;
  border-radius: 8px;
`;

const DebouncedInput = ({ value, onChange, delay = 2000, placeholder, width = 200 }) => {
  const [inputValue, setInputValue] = useState(value || "");

  useEffect(() => {
    const handler = setTimeout(() => {
      onChange(inputValue); // Call onChange only after delay
    }, delay);

    return () => clearTimeout(handler); // Cleanup function
  }, [inputValue, delay, onChange]);

  const searchIconStyle = { color: "#888" }

  return (
    <StyledInput
      placeholder={placeholder}
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      suffix={<SearchOutlined style={searchIconStyle} />}
      width={width}
      allowClear
    />
  );
};

export default DebouncedInput;
